/**
 * Ce fichier permets d'afficher la positions en réel sous forme d'un cercle
 *
 * © Moustapha HENNAWI - Click and Take off - 2021
 */

/*-------------------------------------------------------------------------------------------*/

import { useEffect } from 'react';

import { map } from './Map';

/*-------------------------------------------------------------------------------------------*/

export default function AddSatelliteView() {
  useEffect(() => {
    map.addSource('satetllite', {
      type: 'raster',
      tiles: [
        'https://api.mapbox.com/v4/mapbox.satellite/{z}/{x}/{y}@2x.jpg90?access_token=pk.eyJ1IjoibW91c3RhcGhhaGVubmF3aSIsImEiOiJja2xjc3dpZG8wYjkwMnVtcDYyNDN3MXg5In0.0_on7ZCxMcIfVas5zK2f3A'
      ],
      tileSize: 256
    });

    map.addLayer({
      id: 'satetllite',
      type: 'raster',
      source: 'satetllite',
      minzoom: 14
    });

    return () => {
      if (map.getLayer('satetllite')) {
        map.removeLayer('satetllite');
      }
      if (map.getSource('satetllite')) {
        map.removeSource('satetllite');
      }
    };
  }, []);

  return null;
}
